var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Value',{attrs:{"label":_vm.label,"elevation":_vm.elevation,"color":_vm.color,"rounded":_vm.rounded,"highlight":_vm.highlight,"width":_vm.width}},[_c('Percentage',{attrs:{"value":_vm.value,"decimals":_vm.decimals}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }